import { CSSProperties, ReactNode } from 'react';
import * as S from './styles';
import { FontFamilyType } from '@/styles/theme';

export type TextProps = {
  $size: number;
  $color: string;
  $weight: 'light' | 'regular' | 'medium' | 'bold' | 'semibold';
  $align: 'left' | 'center' | 'right';
  $highContrast: boolean;
  $text: string | ReactNode;
  $quebraTexto?: boolean;
  style?: CSSProperties;
  $underline?: boolean;
  $utilizarReticencias?: boolean;
  $fontFamily?: FontFamilyType;
};

export default function Text(props: TextProps) {
  const {
    $text,
    $fontFamily = 'text',
    $quebraTexto = true,
    $utilizarReticencias = false,
  } = props;
  const propsTexto = {
    ...props,
    $quebraTexto,
    $utilizarReticencias,
    $fontFamily,
  };
  return <S.Texto {...propsTexto}>{$text}</S.Texto>;
}
